/* home.js — page script for index.html and the matching Shopify template.
   Loads after app.js, which defines CONFIG and the shared engine. */
if (typeof CONFIG === 'undefined' || typeof renderShelf === 'undefined')
  throw new Error('app.js must load BEFORE home.js — check the script order in the layout');

renderShelf($('shelfGrid'));

/* ── hero: cycles the presets so the colour transition sells itself ─────────
   Built from availablePresets(), which resolves colour NAMES to hex and drops
   anything out of stock — so the showcase can only ever show something you can
   actually print. The caption is derived from the colours rather than typed,
   so it cannot drift out of sync with what is on screen. */
/* Each name rides the combo customers actually pick for it — Zayed in Lagoon
   (the boys' favourite), Amna in Lilac (the shop's favourite) — never paired by
   position, which once put a boy's name on the pinkest combo in the row. */
const PRESET = Object.fromEntries(availablePresets().map(p => [p.n, p]));
const REEL_PAIRS = [['ZAYED','Lagoon'], ['AMNA','Lilac'], ['SAF','Bubblegum'], ['NOOR','Petal'], ['DUBAI','Meadow']];
const REEL = REEL_PAIRS.filter(([, n]) => PRESET[n]).map(([name, n]) => {
  const p = PRESET[n];
  return { ...p, name, finish:'Raised',
    label: `${name} · ${p.n}, ${nameOf(p.letter, CONFIG.filaments).toLowerCase()} on ` +
           `${nameOf(p.cap, CONFIG.filaments).toLowerCase()}` };
});

const heroSvg = $('hero');
$('heroDots').innerHTML = REEL.map(() => '<i></i>').join('');
let reel = 0, lastName = null;

function showReel(i){
  const d = REEL[i];
  // Only rebuild when the NAME changes; otherwise repaint so the colours melt.
  if (d.name !== lastName) { buildKeychain(heroSvg, d); lastName = d.name; }
  else paintKeychain(heroSvg, d);
  $('heroCap').textContent = d.label;
  $('heroDots').querySelectorAll('i').forEach((el,j) => el.classList.toggle('on', j === i));
}
showReel(0);
// Respect people who asked the OS not to animate things.
if (!matchMedia('(prefers-reduced-motion: reduce)').matches)
  setInterval(() => showReel(reel = (reel + 1) % REEL.length), 2600);

/* ── promo art: a static hero piece ──────────────────────────────────────── */
const promoDesign = availablePresets()[0] || {};

/* ── most loved combos: the builder's row, as keychains you can tap into ──
   One card per best seller, each wearing a name that suits it, and each a link
   that opens the builder already painted in that combo. */
const LOVED_NAMES = { Lilac:'AMNA', Lagoon:'ZAYED', Bubblegum:'SARA', Blush:'NOOR', Meadow:'OMAR',
                      Petal:'MAYA', Marshmallow:'LAYLA', Ocean:'SAIF', Candy:'HIND' };
const LOVED = availablePresets().filter(p => p.sold).map(p => ({ ...p, name: LOVED_NAMES[p.n] || 'PAL' }));
if ($('loved')) {
  $('loved').innerHTML = LOVED.map((p, i) => {
    const q = new URLSearchParams({ name: p.name, letter: p.letter, cap: p.cap, base: p.base, src: 'loved' });
    return `<a class="lovedcard" href="${BUILDER()}?${q}">
      <span class="art"><svg id="loved${i}" role="img" aria-label="${p.name} in ${p.n}"></svg></span>
      <b>${p.n}</b><small>${nameOf(p.letter, CONFIG.filaments).toLowerCase()} on ${nameOf(p.cap, CONFIG.filaments).toLowerCase()}</small>
      <em>Start from this →</em></a>`;
  }).join('');
  LOVED.forEach((p, i) => buildKeychain($(`loved${i}`), { ...p, finish:'Raised' }));
  if ($('lovedsec')) $('lovedsec').hidden = LOVED.length === 0;
}

buildKeychain($('promo'), {name:'PAL', ...promoDesign, finish:'Raised'});
// same belt as the builder: a first paint that raced Fredoka gets one honest
// rebuild when the font settles, so no webview is stuck with the fallback
if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => {
  lastName = null; showReel(reel);
  buildKeychain($('promo'), {name:'PAL', ...promoDesign, finish:'Raised'});
  LOVED.forEach((p, i) => $(`loved${i}`) && buildKeychain($(`loved${i}`), { ...p, finish:'Raised' }));
});
// The three dots beside it show the same colours, rather than a hardcoded copy
// that would drift the moment the palette changed.
document.querySelectorAll('[data-dot]').forEach(el => {
  if (promoDesign[el.dataset.dot]) el.style.background = promoDesign[el.dataset.dot];
});

/* ── the fun clicker ─────────────────────────────────────────────────────── */
const QUIPS = ['It does nothing. That is the point.', 'Satisfying, isn\'t it?',
  'Yes, the real ones feel better.', 'Okay, you clearly need a fidget.',
  'Your thumb is doing great.', 'This is free. The real one is AED 30.'];
let clicks = +(localStorage.getItem('pap.clicks') || 0);
$('clicks').textContent = clicks;
$('clicker').addEventListener('click', () => {
  clicks++;
  localStorage.setItem('pap.clicks', clicks);
  $('clicks').textContent = clicks;
  $('clicker').classList.add('down');
  setTimeout(() => $('clicker').classList.remove('down'), 110);
  if (clicks % 7 === 0) $('clickQuip').textContent = QUIPS[(clicks / 7) % QUIPS.length | 0];
  const pop = document.createElement('span');
  pop.className = 'pop'; pop.textContent = 'click!';
  pop.style.setProperty('--r', (Math.random() * 24 - 12) + 'deg');
  $('clicker').parentNode.append(pop);
  setTimeout(() => pop.remove(), 700);
});
